import { bl_svc_issue_hdr_RowClass } from '../../../dbschema/bl_svc_issue_hdr.model';
import { BaseContainerModel } from '../../base-container.model';


export class ServiceNoteIssueHdrContainerModel extends BaseContainerModel {
  bl_svc_issue_hdr: bl_svc_issue_hdr_RowClass = new bl_svc_issue_hdr_RowClass();
}
